import { kmm } from './kmm';
import { RecordingEvent } from '@norlys-a-s/norlys-play-kmm';

export async function deleteRecording(
  sid?: number,
  eventId?: number,
  seriesid?: number,
  contentId?: number,
  seriesRecording = false,
  cancel = false,
  kmmErrorHandling = true
): Promise<boolean> {
  if (seriesRecording && seriesid !== undefined) {
    if (cancel) {
      return kmm((repo) => repo.cancelSeriesRecording(seriesid), kmmErrorHandling);
    } else {
      return kmm((repo) => repo.deleteSeriesRecording(seriesid), kmmErrorHandling);
    }
  } else if (sid != undefined && eventId != undefined) {
    return kmm(
      (repo) => repo.deleteRecordingEvent(new RecordingEvent(sid, eventId)),
      kmmErrorHandling
    );
  } else if (contentId) {
    return kmm((repo) => repo.deleteRecordingForContentId(contentId), kmmErrorHandling);
  } else {
    throw new Error('No valid parameters provided for deleteRecording');
  }
}

export default deleteRecording;
